// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"I0-z","sponsoredTooltipWrapper":"J0-z","sponsoredTooltip":"K0-z","newCard":"L0-z"};